<template>
  <div class="sarpa-popup snake-report-popup">
    <div class="popup-header" :style="{ background: headerGradient }">
      <div class="popup-header-icon">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
          <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"/>
        </svg>
      </div>
      <div class="popup-header-text">
        <div class="popup-entity-name">{{ data.rescue && data.rescue.snake && data.rescue.snake.name ? data.rescue.snake.name : 'Snake Report' }}</div>
        <div class="popup-entity-sub" style="display:flex;align-items:center;gap:5px;">
          <span class="status-badge-small">{{ data.situation || data.status || 'Pending' }}</span>
        </div>
      </div>
    </div>

    <div class="popup-body">
      <div class="popup-row" v-if="data._id">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="#6b7280"><path d="M17 3H7c-1.1 0-2 .9-2 2v16l7-3 7 3V5c0-1.1-.9-2-2-2z"/></svg>
        <span class="popup-id">ID: {{ shortId(data._id) }}</span>
      </div>
      <div class="popup-row" v-if="data.district">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="#6b7280"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z"/></svg>
        <span>{{ data.district }}</span>
      </div>
      <div class="popup-row" v-if="reporterName">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="#6b7280"><path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"/></svg>
        <span>Reporter: {{ reporterName }}</span>
      </div>
      <div class="popup-row" v-if="rescuerName">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="#6b7280"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"/></svg>
        <span>Rescuer: {{ rescuerName }}</span>
      </div>
      <div class="popup-row" v-if="data.create_date || data.createdAt">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="#6b7280"><path d="M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z"/></svg>
        <span>{{ formatDate(data.create_date || data.createdAt) }}</span>
      </div>
    </div>

    <div class="popup-actions">
      <button class="popup-btn primary snake-btn" @click="openDetails">
        Open Details
        <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor"><path d="M8.59 16.59L13.17 12 8.59 7.41 10 6l6 6-6 6-1.41-1.41z"/></svg>
      </button>
    </div>
  </div>
</template>

<script>
import { getSnakeReportColor } from '../constants/statusColors';

export default {
  name: 'SnakeReportPopup',
  props: {
    data: { type: Object, required: true },
  },
  computed: {
    statusColor() {
      return getSnakeReportColor(this.data.situation || this.data.status);
    },
    headerGradient() {
      const c = this.statusColor;
      return `linear-gradient(135deg, ${c} 0%, ${c}cc 100%)`;
    },
    reporterName() {
      return this.data.user && this.data.user.name ? this.data.user.name : null;
    },
    rescuerName() {
      return this.data.rescuer && this.data.rescuer.name ? this.data.rescuer.name
           : this.data.rescuerId && this.data.rescuerId.name ? this.data.rescuerId.name
           : null;
    },
  },
  methods: {
    shortId(id) {
      return id ? '…' + id.slice(-6) : '-';
    },
    formatDate(d) {
      if (!d) return '-';
      try { const [y, m, day] = d.slice(0, 10).split('-'); return `${day}-${m}-${y}`; }
      catch { return d; }
    },
    openDetails() {
      if (this.$router && this.data._id) {
        this.$router.push({ name: 'viewSnakeReport', query: { id: this.data._id } });
      }
    },
  },
};
</script>

<style>
.snake-report-popup .status-badge-small {
  font-size: 9.5px;
  font-family: poppinsmedium, sans-serif;
  background: rgba(255,255,255,0.25);
  color: #fff;
  padding: 2px 7px;
  border-radius: 10px;
  text-transform: capitalize;
}
.snake-report-popup .popup-id {
  font-family: monospace;
  font-size: 11.5px;
  color: #6b7280;
}
.snake-report-popup .snake-btn {
  background: linear-gradient(135deg, #FF6907 0%, #F59E0B 100%);
}
</style>
